import { createSelector } from '@reduxjs/toolkit';

import { portalTypeSelector } from '../../../app/selectors/portal-type.selector';
import {
  ACCOUNT_LINKING_TERMS_DOC,
  CREDIT_REPORT_AUTH_DOC,
  LegalDocument,
  OTP_APPLY_LEGAL_DOCUMENTS,
  OTP_VERIFICATION_LEGAL_DOCUMENTS,
} from '../../../domain/config';
import { RootState } from '../../../store';

const all_documents = ({ config: { config } }: RootState): LegalDocument[] => {
  return config?.documents ?? [];
};

const all_documents_by_key = createSelector([all_documents], (documents) => {
  return new Map(documents.map((doc) => [doc.key, doc]));
});

const otpLegalDocumentSelector = createSelector(
  [all_documents_by_key, portalTypeSelector],
  (document_map, portalType) => {
    const legalDocs = portalType === 'apply' ? OTP_APPLY_LEGAL_DOCUMENTS : OTP_VERIFICATION_LEGAL_DOCUMENTS;
    return legalDocs.filter((key) => document_map.has(key)).map((key) => document_map.get(key)!);
  },
);

const creditReportAuthorizationSelector = createSelector(
  [all_documents_by_key],
  (doc_map) => doc_map.get(CREDIT_REPORT_AUTH_DOC) ?? null,
);

const accountLinkingTermsSelector = createSelector(
  [all_documents_by_key],
  (doc_map) => doc_map.get(ACCOUNT_LINKING_TERMS_DOC) ?? null,
);

const singleDocumentSelector = (key: string) => {
  return createSelector([all_documents], (documents) => {
    return documents.find((document) => document.key === key) ?? null;
  });
};

const cardProgramTermsSelector = singleDocumentSelector('card_program_terms');

const platformAgreementSelector = singleDocumentSelector('platform_terms');

const privacyPolicySelector = singleDocumentSelector('privacy_policy');

export {
  otpLegalDocumentSelector,
  creditReportAuthorizationSelector,
  cardProgramTermsSelector,
  accountLinkingTermsSelector,
  platformAgreementSelector,
  privacyPolicySelector,
};
